import { CALL_API } from "admin/middlewares/api";

export const SSN_BLOCK_INFO_DATA_FETCH_REQUEST =
  "SSN_BLOCK_INFO_DATA_FETCH_REQUEST";
export const SSN_BLOCK_INFO_DATA_FETCH_SUCCESS =
  "SSN_BLOCK_INFO_DATA_FETCH_SUCCESS";
export const SSN_BLOCK_INFO_DATA_FETCH_ERROR =
  "SSN_BLOCK_INFO_DATA_FETCH_ERROR";

export function fetch_ssn_block_info(ssn) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/is-ssn-blocked?ssn=" + ssn,
      authenticatedRequest: true,
      additionalData: { Ssn: ssn },
      types: [
        SSN_BLOCK_INFO_DATA_FETCH_REQUEST,
        SSN_BLOCK_INFO_DATA_FETCH_SUCCESS,
        SSN_BLOCK_INFO_DATA_FETCH_ERROR,
      ],
    },
  };
}
